import type { OpenAIVideoModel } from "@farzin/contracts";

export interface ModelExperience {
  readonly eyebrow: string;
  readonly heroLead: string;
  readonly heroEmphasis: string;
  readonly description: string;
  readonly onlineLabel: string;
  readonly storyHint: string;
  readonly submitLabel: string;
}

const EXPERIENCES: Readonly<Record<OpenAIVideoModel, ModelExperience>> = {
  "sora-2": {
    eyebrow: "RAPID PIXEL LAB · SORA 2",
    heroLead: "Sketch a tiny world.",
    heroEmphasis: "See it move.",
    description:
      "A fast creative lab for focused scenes, bold silhouettes, and quick pixel-film exploration.",
    onlineLabel: "RAPID ENGINE",
    storyHint: "Keep one action clear and let the strongest visual idea lead.",
    submitLabel: "Render rapid draft",
  },
  "sora-2-pro": {
    eyebrow: "PRO PIXEL ATELIER · SORA 2 PRO",
    heroLead: "Direct every detail.",
    heroEmphasis: "Render the final film.",
    description:
      "A cinematic atelier tuned for native 1080p detail, stable geometry, and production-quality pixel films.",
    onlineLabel: "PRO ENGINE",
    storyHint:
      "Describe the exact composition, lighting, character action, and details that must remain stable.",
    submitLabel: "Render master film",
  },
};

export function getModelExperience(model: OpenAIVideoModel): ModelExperience {
  return EXPERIENCES[model];
}
